// extracted by mini-css-extract-plugin
export var letter = "tabs-panel-module--letter--5e33e";
export var letterBtn = "tabs-panel-module--letter-btn--517f6";
export var tabsPanel = "tabs-panel-module--tabs-panel--9b687";